import { Modal } from "shared/components";
import { PromoContentComponentProps, PromoType } from "../types";
import { useState } from "react";
import { PromoContent } from "../Content";
import { markPromoAsSeen } from "../utils";

export const PromoModal = (
  props: Omit<PromoContentComponentProps, "promoType">
) => {
  const [isOpened, setIsOpened] = useState(true);

  const close = () => {
    props.onClose?.();
    setIsOpened(false);
  };

  return (
    <Modal
      opened={isOpened}
      onClose={() => {
        // Esc / backdrop dismissal has to persist exactly like the Close button,
        // which marks the promo itself before calling onClose.
        markPromoAsSeen(props.featureName, PromoType.Modal);
        close();
      }}
    >
      <PromoContent {...props} promoType={PromoType.Modal} onClose={close} />
    </Modal>
  );
};
